import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/HomeView.vue'),
  },
  {
    path: '/products',
    name: 'Products',
    component: () => import('../views/ProductsView.vue'),
  },
  {
    path: '/om-oss',
    name: 'About',
    component: () => import('../views/AboutView.vue'),
  },
  {
    path: '/kontakt',
    name: 'Contact',
    component: () => import('../views/ContactView.vue'),
  },
  {
    path: '/vanliga-fragor',
    name: 'FAQ',
    component: () => import('../views/FaqView.vue'),
  },
  // Nyheter-sidan är pausad
  // {
  //   path: '/nyheter',
  //   name: 'News',
  //   component: () => import('../views/NewsView.vue'),
  // },
  // Parkera-sidan är pausad enligt specifikation 16 februari 2026
  // {
  //   path: '/parkera',
  //   name: 'Park',
  //   component: () => import('../views/ParkView.vue'),
  // },
  {
    path: '/privatkund',
    name: 'Individual',
    component: () => import('../views/IndividualView.vue'),
  },
  {
    path: '/fastighetsagare',
    name: 'PropertyOwner',
    component: () => import('../views/PropertyOwnerView.vue'),
  },
  {
    path: '/bostadsrattsforening',
    name: 'Coop',
    component: () => import('../views/CoopView.vue'),
  },
  {
    path: '/kommuner',
    name: 'Municipality',
    component: () => import('../views/MunicipalityView.vue'),
  },
  {
    path: '/parkeringsbolag',
    name: 'ParkingCompany',
    component: () => import('../views/ParkingCompanyView.vue'),
  },
  {
    path: '/airpark-portal',
    name: 'AirParkPortal',
    component: () => import('../views/AirParkPortalView.vue'),
  },
  {
    path: '/airpark-app',
    name: 'AirParkApp',
    component: () => import('../views/AirParkAppView.vue'),
  },
  {
    path: '/airpass',
    name: 'AirPass',
    component: () => import('../views/AirPassView.vue'),
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('../views/PrivacyPolicyView.vue'),
  },
  {
    path: '/cookie-policy',
    name: 'CookiePolicy',
    component: () => import('../views/CookiePolicyView.vue'),
  },
  {
    path: '/case/oceanhamnen',
    name: 'CaseOceanhamnen',
    component: () => import('../views/CaseOceanhamnView.vue'),
  },
  {
    path: '/case/lkp',
    name: 'CaseLKP',
    component: () => import('../views/CaseLKPView.vue'),
  },
  {
    path: '/case/rogle',
    name: 'CaseRogle',
    component: () => import('../views/CaseRogleView.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
})

// SPA Pageview Tracking - Skicka sidvisningar till Google Analytics
router.afterEach((to) => {
  // Vänta tills sidan är renderad
  setTimeout(() => {
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', 'page_view', {
        page_path: to.path,
        page_title: to.name?.toString() || document.title,
        page_location: window.location.href
      })
    }
  }, 100)
})

export default router

